import React from 'react';

import { ActiveHighlightableString } from './ActiveHighlightableString';
import {
  getFullContent,
  HighlightableString,
  HighlightableStringPart,
} from './HighlightableString';

type Props = {
  className?: string;
  string: DeepReadonly<HighlightableString>;
};

export class HighlightableStringView extends React.Component<Props> {
  render() {
    const str = this.props.string;

    let cssPartClass = 'highlightableStringViewPart';
    if (this.props.className) {
      cssPartClass += ` ${this.props.className}`;
    }

    let partsToRender: DeepReadonly<HighlightableStringPart[]>;
    if (typeof str.highlighted === 'undefined') {
      partsToRender = str.originalParts;
    } else {
      partsToRender = str.highlighted.parts;
    }

    const partSpans = partsToRender.map((part, index) => {
      const classes = [cssPartClass];
      if (typeof part.cssClasses !== 'undefined') {
        classes.push(...part.cssClasses);
      }

      let id: string | undefined;

      if (part.highlighted) {
        classes.push(...part.highlighted.highlightedBy);

        if (ActiveHighlightableString.getActivePartIds().includes(part.highlighted.htmlId)) {
          classes.push('highlightableStringViewPartActive');
        }

        id = part.highlighted.htmlId;
      }

      const partCssClassNames = classes.join(' ');

      return (
        <span key={index} id={id} className={partCssClassNames}>
          {part.length > 0
            ? getFullContent(str).substring(part.startIndex, part.startIndex + part.length)
            : ''}
        </span>
      );
    });

    return <span>{partSpans}</span>;
  }
}
